module.exports = "/assets/data/a4344f988cd546e872d17388fef27036-NG4.data.json";